module.exports = __webpack_public_path__ + "img/MIDI-arpeggiator-plugin-vst-red.bd04e9e3.png";